import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientMedicationsService } from '../../patientMedications/services/patientMedications.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setDoseUnitOptions } from '../store/options.actions'

export function* getDoseUnits() {
  const serviceId: string = yield select(getServiceIdSelector)
  const medicationService = new PatientMedicationsService(serviceId)
  try {
    const doseUnitsResponse: IOptionsResponse = yield call([medicationService, medicationService.getDoseUnitsOptions])
    const { entity } = doseUnitsResponse
    yield put(setDoseUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDoseUnits() error: ${e}`))
  }
}

export function* getDoseUnitsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDoseUnits)
}
